export interface GeneralItem {
    id: number;
    name: string;
    note: string;
    disease_type: string;
    special_notes: string;
  }
  
  export interface HabitsItem {
    id: number;
    type_if_substance: string;
    quantity_per_day: string;
    duration_in_years: string;
    quit_date: string;
  }
  
  export interface OtherItem {
    id: number;
    disease_with_date: string;
    surgery_institution: string;
    edit: string;
  }
  
  export interface GeneralHealthInfoCategory {
    id: number;
    category: string;
    expanded: boolean;
    generalItem: GeneralItem[];
    habitsItem: HabitsItem[];
    otherItem: OtherItem[];
  }
  
  export const GeneralHealthInfoData: GeneralHealthInfoCategory[] = [
    {
      id: 1,
      category: "Alerjiler",
      expanded: false,
      generalItem: [
        {
          id: 1,
          name: "Besin Alerjisi",
          note: "Olası",
          disease_type: "Alerji",
          special_notes: "Dikkat edilmeli",
        },
        {
          id: 2,
          name: "İlaç Alerjisi",
          note: "Kesin",
          disease_type: "Alerji",
          special_notes: "Kullanılmamalı",
        },
      ],
      habitsItem: [],
      otherItem: [],
    },
    {
      id: 2,
      category: "Alışkanlıklar",
      expanded: false,
      generalItem: [],
      habitsItem: [
        {
          id: 1,
          type_if_substance: "Anne Sigara",
          quantity_per_day: "10",
          duration_in_years: "5",
          quit_date: "2025-06-01",
        },
        {
          id: 2,
          type_if_substance: "Anne Alkol",
          quantity_per_day: "1",
          duration_in_years: "3",
          quit_date: "2025-01-01",
        },
      ],
      otherItem: [],
    },
    {
      id: 3,
      category: "Soy Geçmiş",
      expanded: false,
      generalItem: [
        {
          id: 3,
          name: "Genetik Hastalıklar",
          note: "Ailevi",
          disease_type: "Geçmiş",
          special_notes: "Dikkat edilmesi gerekir",
        },
      ],
      habitsItem: [],
      otherItem: [],
    },
    {
      id: 4,
      category: "Geçirilmiş Hastalıklar",
      expanded: false,
      generalItem: [
        {
          id: 4,
          name: "Sarılık",
          note: "Tedavi edildi",
          disease_type: "Hastalık",
          special_notes: "Takip gerekli",
        },
      ],
      habitsItem: [],
      otherItem: [],
    },
    {
      id: 5,
      category: "Hastalıklar",
      expanded: false,
      generalItem: [
        {
          id: 5,
          name: "Konjenital Anomali",
          note: "Doğumsal",
          disease_type: "Hastalık",
          special_notes: "Takip edilmeli",
        },
      ],
      habitsItem: [],
      otherItem: [],
    },
    {
      id: 6,
      category: "Geçirilmiş Ameliyatlar",
      expanded: false,
      generalItem: [
        {
          id: 6,
          name: "Sezaryen",
          note: "Başarılı",
          disease_type: "Ameliyat",
          special_notes: "Anne bilgileri",
        },
      ],
      habitsItem: [],
      otherItem: [],
    },
    {
      id: 7,
      category: "Özel Notlar",
      expanded: false,
      generalItem: [
        {
          id: 7,
          name: "Beslenme",
          note: "Özel diyet",
          disease_type: "Özel",
          special_notes: "Sık beslenmeli",
        },
      ],
      habitsItem: [],
      otherItem: [],
    },
    {
      id: 8,
      category: "Nadir Hastalıklar",
      expanded: false,
      generalItem: [
        {
          id: 8,
          name: "Metabolik Hastalıklar",
          note: "Tarama yapıldı",
          disease_type: "Nadir",
          special_notes: "Sonuç bekleniyor",
        },
      ],
      habitsItem: [],
      otherItem: [],
    },
    {
      id: 9,
      category: "Tansiyon Takibi",
      expanded: false,
      generalItem: [],
      habitsItem: [],
      otherItem: [
        {
          id: 1,
          disease_with_date: "12.04.2025 - 60/40 mmHg",
          surgery_institution: "",
          edit: "",
        },
      ],
    },
    {
      id: 10,
      category: "Maruziyetler",
      expanded: false,
      generalItem: [
        {
          id: 9,
          name: "Çevresel Faktörler",
          note: "Pasif sigara içiciliği",
          disease_type: "Maruziyet",
          special_notes: "Korunması gerekli",
        },
      ],
      habitsItem: [],
      otherItem: [],
    },
    {
      id: 11,
      category: "Kullandığı İlaçlar",
      expanded: false,
      generalItem: [
        {
          id: 10,
          name: "D Vitamini",
          note: "Günlük",
          disease_type: "Takviye",
          special_notes: "Doktor önerisi",
        },
      ],
      habitsItem: [],
      otherItem: [],
    },
  ];